import React from "react";
import { Mail, ArrowDown, FileText } from "lucide-react";
import { GithubIcon, InstagramIcon } from "../components/BrandIcons";
import { ScrollReveal } from "../components/ScrollReveal";

export const Contact: React.FC = () => {
  return (
    <section className="section-space" id="bicara">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <ScrollReveal>
          <div className="flex items-baseline justify-between mb-12">
            <h2 className="text-sm uppercase tracking-widest text-muted-foreground font-medium">
              Bicara
            </h2>
            <span className="text-sm text-muted-foreground">Hubungi saya</span>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
          {/* Primary CTA */}
          <div className="md:col-span-8">
            <ScrollReveal>
              <p className="text-muted-foreground mb-6 max-w-lg">
                Tertarik berkolaborasi atau sekadar menyapa? Saya selalu terbuka untuk diskusi
                tentang produk, teknologi, dan segala kemungkinan menarik di antaranya.
              </p>
              <a
                href="mailto:akbarwidya.dev@gmail.com"
                className="group inline-flex items-center gap-3 text-3xl md:text-5xl font-bold text-foreground tracking-tight hover:text-primary transition-colors duration-300"
              >
                <Mail className="w-8 h-8 md:w-12 md:h-12 transition-transform duration-300 group-hover:scale-110" />
                <span className="underline underline-offset-4 decoration-border group-hover:decoration-primary transition-all duration-300">
                  akbarwidya.dev@gmail.com
                </span>
              </a>
            </ScrollReveal>
          </div>

          {/* Secondary Links */}
          <div className="md:col-span-4 flex flex-col gap-6">
            <ScrollReveal delay={0.1}>
              <span className="text-xs uppercase tracking-widest text-muted-foreground mb-4 block">
                Tautan
              </span>
              <div className="flex flex-col gap-4">
                <a
                  href="https://github.com/akbar-widya"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center gap-2.5 text-foreground hover:text-primary transition-colors duration-300"
                >
                  <GithubIcon className="w-5 h-5" />
                  <span className="font-medium">GitHub</span>
                  <ArrowDown className="w-4 h-4 -rotate-45 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                </a>

                <a
                  href="https://instagram.com/akbarwidya.dev"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center gap-2.5 text-foreground hover:text-primary transition-colors duration-300"
                >
                  <InstagramIcon className="w-5 h-5" />
                  <span className="font-medium">Instagram</span>
                  <ArrowDown className="w-4 h-4 -rotate-45 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                </a>

                <a
                  href="/cv-akbar.pdf"
                  download
                  className="group inline-flex items-center gap-2.5 text-foreground hover:text-primary transition-colors duration-300"
                >
                  <FileText className="w-5 h-5" />
                  <span className="font-medium">Unduh CV (PDF)</span>
                  <ArrowDown className="w-4 h-4 opacity-0 -translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300" />
                </a>
              </div>
            </ScrollReveal>
          </div>
        </div>

        {/* Footer subtle */}
        <div className="mt-24 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Akbar Widya Pamungkas
          </p>
          <p className="text-sm text-muted-foreground">
            Dibangun dengan React, Tailwind CSS, dan GSAP
          </p>
        </div>
      </div>
    </section>
  );
};
